import React from 'react';
import { Species } from '../../../types/gql-op-types';
import RescueChipModule from './RescueChipModule';
import RescueTestimonials from './RescueTestimonials';

/**
 * Ordered list of the below-fold blocks that only the rescue adoption variant renders. Both sit
 * outside the product-details container: that is what lets the chip module's dark panel run edge to
 * edge, and it puts the testimonials directly beneath the objection they answer.
 *
 * Cat adopters skip the testimonials: every quote is about a dog, and there are no cat quotes yet.
 */
export default function RescueSections({ species }: { species: Species }) {
  return (
    <>
      <RescueChipModule species={species} />
      {species !== Species.CAT && <RescueTestimonials />}
    </>
  );
}
